"use client";

import Link from "next/link";
import { useSelectedLayoutSegment } from "next/navigation";
import { useRouter, usePathname } from "next/navigation";
import { toast } from "sonner";
import { useTranslations } from "next-intl";
import { useSession } from "next-auth/react";

export function TokenLink() {
  const segment = useSelectedLayoutSegment();
  const router = useRouter();
  const t = useTranslations("header");
  const pathname = usePathname();
  const locale = pathname?.split("/")[1] || "zh";
  const { status } = useSession();

  const handleClick = (e: React.MouseEvent) => {
    if (status !== "authenticated") {
      e.preventDefault();
      toast.error(t("alerts.loginRequired"));
      router.push(`/${locale}/login`);
    }
  };

  return (
    <Link
      href={`/${locale}/tokenpg`}
      rel="noopener noreferrer"
      className="text-foreground/60 transition-colors hover:text-foreground"
      onClick={handleClick}
    >
      {t("nav.token")}
    </Link>
  );
}
